/**
 * Whether a pickup is tinted by how rare it is.
 *
 * Writes to [rarityColour](../../hud/rarityColour.ts), which the HUD frame reads per tick and puts
 * on the layer as one class, so a notice already on screen loses its tint on the next update.
 *
 * The knob is not the accessibility fix on its own: the marks and the band's word are what make a
 * rarity legible, and both are drawn whatever this is set to. What the switch buys is a build where
 * the colour can be taken away and the answer is still there, which is a property somebody can
 * photograph rather than one somebody remembers to preserve.
 */

import { DEFAULT_RARITY_COLOUR, setRarityColour } from '@/ui/hud/rarityColour';
import { SETTING_RARITY_COLOUR_HINT, SETTING_RARITY_COLOUR_LABEL } from '@/text/settingsText';
import { toggleApply, toggleValue } from '@/ui/settings/controls/toggleSwitch';
import type { SettingDefinition } from '@/ui/settings/settingContract';

export const RARITY_COLOUR: SettingDefinition = {
  id: 'rarityColour',
  section: 'accessibility',
  label: SETTING_RARITY_COLOUR_LABEL,
  hint: SETTING_RARITY_COLOUR_HINT,
  control: { kind: 'toggle' },
  defaultValue: toggleValue(DEFAULT_RARITY_COLOUR),
  apply: toggleApply(setRarityColour),
};
